<button
    [name]="config?.name ?? ''"
    [id]="config?.id ?? ''"
    [ngClass]="{
        '-without-icon': !config?.icon,
        '-without-label': !config?.label,
        'zt-btn--disabled': disabled,
        'zt-btn--loading': loading,
        'zt-btn--rounded': rounded
    }"
    class="zt-btn {{ type }}"
    (click)="onClickListener()"
    role="button"
    [disabled]="disabled"
    [attr.aria-disabled]="disabled"
>
    <ng-template [ngIf]="!loading" [ngIfElse]="loader">
        <ng-template [ngIf]="config?.icon">
            <zt-icon [icon]="config?.icon"></zt-icon>
        </ng-template>
        <div *ngIf="config?.label" class="label select-none">
            {{ config?.label }}
        </div>
    </ng-template>
    <ng-template #loader>
        <i>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                />
            </svg>
        </i>
    </ng-template>
</button>
